import { ACTION_TYPE } from '../core/redux/actionType';
import { hasTrippedBreaker, updateBreaker } from '../core/redux/api/circuitBreaker/module';
import { apiGuestDetails } from '../core/redux/api/endpoints';
import { addError, addLoading, getLoading, removeLoadingAndError } from '../core/redux/api/module';
import { ApiReducer, makeApiAction, makeApiReducer, RsaaTypes } from '../core/redux/api/reduxStandardApiAction';
import { IAppState } from '../core/redux/IAppState';
import { GuestDetails } from './guestDetails';
import { addGuest } from './module';


const KEY_ACTION = ACTION_TYPE.GUEST_DETAILS_REQUEST;
const ACTIONS    = [
  ACTION_TYPE.GUEST_DETAILS_REQUEST,
  ACTION_TYPE.GUEST_DETAILS_RESPONSE,
  ACTION_TYPE.GUEST_DETAILS_ERROR,
];


/**
 * Constructs a guest details Redux Action for getting the guest details for a specific guest ID
 * @param guestId - The guest whose household we want to get
 */
export const getGuestDetailsAction = (guestId: string) => makeApiAction(
  {
    method:   'GET',
    endpoint: apiGuestDetails(encodeURIComponent(guestId)),
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    types:    ACTIONS.map(action => ({ type: action, meta: { guestId } })) as RsaaTypes,
    bailout:  state => !!getLoading(state, guestId, KEY_ACTION) || hasTrippedBreaker(state, KEY_ACTION),
  },
);


const reducer: ApiReducer<GuestDetails> = (state, action, error, isLoading, payload) => {
  const guestId = action.meta.guestId;

  if (isLoading) {
    return addLoading(state, guestId, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error) {
    return addError(withBreaker, guestId, KEY_ACTION, error);
  }

  const noLoadingOrError = removeLoadingAndError(withBreaker, guestId, KEY_ACTION);

  if (!payload){
    return noLoadingOrError;
  }
  
  return addGuest(noLoadingOrError, payload!);
};


export const getGuestDetailsReducer = makeApiReducer<GuestDetails>(ACTIONS, KEY_ACTION, reducer);
